export const TIMEZONE_VALUES = [
    {
        TimeZoneId: "Dateline Standard Time",
        TimeSpan: "-12:00",
        Location: "International Date Line West",
        CurrentTimeZone: false,
        HoursUtcOffset: -12,
        OffsetValue: 720,
    },
    {
        TimeZoneId: "UTC-11",
        TimeSpan: "-11:00",
        Location: "Coordinated Universal Time-11",
        CurrentTimeZone: false,
        HoursUtcOffset: -11,
        OffsetValue: 660,
    },
    {
        TimeZoneId: "Hawaiian Standard Time",
        TimeSpan: "-10:00",
        Location: "Hawaii",
        CurrentTimeZone: false,
        HoursUtcOffset: -10,
        OffsetValue: 600
    },
    {
        TimeZoneId: "Marquesas Standard Time",
        TimeSpan: "-09:30",
        Location: "Marquesas Islands",
        CurrentTimeZone: false,
        HoursUtcOffset: -9.5,
        OffsetValue: 570,
    },
    {
        TimeZoneId: "Aleutian Standard Time",
        TimeSpan: "-09:00",
        Location: "Aleutian Islands",
        CurrentTimeZone: false,
        HoursUtcOffset: -9,
        OffsetValue: 540,
    },
    {
        TimeZoneId: "Alaskan Standard Time",
        TimeSpan: "-08:00",
        Location: "Alaska",
        CurrentTimeZone: false,
        HoursUtcOffset: -8,
        OffsetValue: 480,
    },
    {
        TimeZoneId: "Pacific Standard Time",
        TimeSpan: "-07:00",
        Location: "Pacific Time (US & Canada)",
        CurrentTimeZone: false,
        HoursUtcOffset: -7,
        OffsetValue: 420,
    },
    {
        TimeZoneId: "Mountain Standard Time",
        TimeSpan: "-06:00",
        Location: "Mountain Time (US & Canada)",
        CurrentTimeZone: false,
        HoursUtcOffset: -6,
        OffsetValue: 360,
    },
    {
        TimeZoneId: "Central Standard Time",
        TimeSpan: "-05:00",
        Location: "Central Time (US & Canada)",
        CurrentTimeZone: false,
        HoursUtcOffset: -5,
        OffsetValue: 300,
    },
    {
        TimeZoneId: "Eastern Standard Time",
        TimeSpan: "-04:00",
        Location: "Eastern Time (US & Canada)",
        CurrentTimeZone: false,
        HoursUtcOffset: -4,
        OffsetValue: 240,
    },{
        TimeZoneId: "Argentina Standard Time",
        TimeSpan: "-03:00",
        Location: "City of Buenos Aires",
        CurrentTimeZone: false,
        HoursUtcOffset: -3,
        OffsetValue: 180,
    },
    {
        TimeZoneId: "Newfoundland Standard Time",
        TimeSpan: "-02:30",
        Location: "Newfoundland",
        CurrentTimeZone: false,
        HoursUtcOffset: -2.5,
        OffsetValue: 150,
    },
    {
        TimeZoneId: "Greenland Standard Time",
        TimeSpan: "-02:00",
        Location: "Greenland",
        CurrentTimeZone: false,
        HoursUtcOffset: -2,
        OffsetValue: 120,
    },
    {
        TimeZoneId: "Mid-Atlantic Standard Time",
        TimeSpan: "-01:00",
        Location: "Mid-Atlantic - Old",
        CurrentTimeZone: false,
        HoursUtcOffset: -1,
        OffsetValue: 60,
    },
    {
        TimeZoneId: "Greenwich Standard Time",
        TimeSpan: "",
        Location: "Monrovia, Reykjavik",
        CurrentTimeZone: false,
        HoursUtcOffset: 0,
        OffsetValue: 0,
    },
    {
        TimeZoneId: " Standard Time",
        TimeSpan: "+01:00",
        Location: "Dublin, Edinburgh, Lisbon, London",
        CurrentTimeZone: false,
        HoursUtcOffset: 1,
        OffsetValue: -60,
    },
    {
        TimeZoneId: "Central Europe Standard Time",
        TimeSpan: "+02:00",
        Location: "Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        CurrentTimeZone: false,
        HoursUtcOffset: 2,
        OffsetValue: -120,
    },
    {
        TimeZoneId: "Middle East Standard Time",
        TimeSpan: "+03:00",
        Location: "Beirut",
        CurrentTimeZone: false,
        HoursUtcOffset: 3,
        OffsetValue: -180,
    },
    {
        TimeZoneId: "Iran Standard Time",
        TimeSpan: "+03:30",
        Location: "Tehran",
        CurrentTimeZone: false,
        HoursUtcOffset: 3.5,
        OffsetValue: -210,
    },
    {
        TimeZoneId: "Arabian Standard Time",
        TimeSpan: "+04:00",
        Location: "Abu Dhabi, Muscat",
        CurrentTimeZone: false,
        HoursUtcOffset: 4,
        OffsetValue: -240,
    },
    {
        TimeZoneId: "West Asia Standard Time",
        TimeSpan: "+05:00",
        Location: "Ashgabat, Tashkent",
        CurrentTimeZone: false,
        HoursUtcOffset: 5,
        OffsetValue: -300,
    },
    {
        TimeZoneId: "India Standard Time",
        TimeSpan: "+05:30",
        Location: "Chennai, Kolkata, Mumbai, New Delhi",
        CurrentTimeZone: false,
        HoursUtcOffset: 5.5,
        OffsetValue: -330,
    },
    {
        TimeZoneId: "Nepal Standard Time",
        TimeSpan: "+05:45",
        Location: "Kathmandu",
        CurrentTimeZone: false,
        HoursUtcOffset: 5.75,
        OffsetValue: -345,
    },
    {
        TimeZoneId: "Central Asia Standard Time",
        TimeSpan: "+06:00",
        Location: "Astana",
        CurrentTimeZone: false,
        HoursUtcOffset: 6,
        OffsetValue: -360,
    },
    {
        TimeZoneId: "Myanmar Standard Time",
        TimeSpan: "+06:30",
        Location: "Yangon (Rangoon)",
        CurrentTimeZone: false,
        HoursUtcOffset: 6.5,
        OffsetValue: -390,
    },
    {
        TimeZoneId: "North Asia Standard Time",
        TimeSpan: "+07:00",
        Location: "Krasnoyarsk",
        CurrentTimeZone: false,
        HoursUtcOffset: 7,
        OffsetValue: -420,
    },
    {
        TimeZoneId: "China Standard Time",
        TimeSpan: "+08:00",
        Location: "Beijing, Chongqing, Hong Kong, Urumqi",
        CurrentTimeZone: false,
        HoursUtcOffset: 8,
        OffsetValue: -480,
    },
    {
        TimeZoneId: "Aus Central W. Standard Time",
        TimeSpan: "+08:45",
        Location: "Eucla",
        CurrentTimeZone: false,
        HoursUtcOffset: 8.75,
        OffsetValue: -525,
    },
    {
        TimeZoneId: "Tokyo Standard Time",
        TimeSpan: "+09:00",
        Location: "Osaka, Sapporo, Tokyo",
        CurrentTimeZone: false,
        HoursUtcOffset: 9,
        OffsetValue: -540,
    },
    {
        TimeZoneId: "AUS Central Standard Time",
        TimeSpan: "+09:30",
        Location: "Darwin",
        CurrentTimeZone: false,
        HoursUtcOffset: 9.5,
        OffsetValue: -570,
    },
    {
        TimeZoneId: "Cen. Australia Standard Time",
        TimeSpan: "+10:30",
        Location: "Adelaide",
        CurrentTimeZone: false,
        HoursUtcOffset: 10.5,
        OffsetValue: -630,
    },
    {
        TimeZoneId: "E. Australia Standard Time",
        TimeSpan: "+10:00",
        Location: "Brisbane",
        CurrentTimeZone: false,
        HoursUtcOffset: 10,
        OffsetValue: -600,
    },{
        TimeZoneId: "Central Pacific Standard Time",
        TimeSpan: "+11:00",
        Location: "Solomon Is., New Caledonia",
        CurrentTimeZone: false,
        HoursUtcOffset: 11,
        OffsetValue: -660,
    }, 
    {
        TimeZoneId: "Norfolk Standard Time",
        TimeSpan: "+12:00",
        Location: "Norfolk Island",
        CurrentTimeZone: false,
        HoursUtcOffset: 12,
        OffsetValue: -720,
    },
    {
        TimeZoneId: "Kamchatka Standard Time",
        TimeSpan: "+13:00",
        Location: "Petropavlovsk-Kamchatsky - Old",
        CurrentTimeZone: false,
        HoursUtcOffset: 13,
        OffsetValue: -780,
    },
    {
        TimeZoneId: "Line Islands Standard Time",
        TimeSpan: "+14:00",
        Location: "Kiritimati Island",
        CurrentTimeZone: false,
        HoursUtcOffset: 14,
        HoursUtcOffset: -840,
    }
];
